import createReactComponent from '../createReactComponent';
export default createReactComponent('math-not', 'IconMathNot', [
  ['path', { d: 'M5 12h14v4', key: 'svg-0' }],
]);
